import { useState, useEffect } from 'react';
import { APIEndpoint, EndpointType, httpGet } from '../utils/apiService'
import { StorefrontResponse, Storefront } from '../models/StorefrontResponse';

const apiURL = APIEndpoint(EndpointType.Storefront);

export const useStorefrontManager = (name: string) => {
    const [storefront, setStorefront] = useState<Storefront>(defaultStorefront);
    const [storefrontError, setError] = useState("")
    const [storefrontLoading, setLoading] = useState(false)

    useEffect(() => {
        if (name == '') {
            return
        }

        setLoading(true)
        setError("")
        setStorefront(defaultStorefront)
        httpGet(apiURL + '/' + name)
            .then((data) => {
                const storefrontResponse = data as StorefrontResponse;

                if (storefrontResponse.status == "error") {
                    setError(storefrontResponse.errorMessage)
                    return
                }

                if (storefrontResponse.storefronts) {
                    if (storefrontResponse.storefronts.length > 0) {
                        const sf = storefrontResponse.storefronts[0]
                        sf.activeColors = sf.lightMode
                        setStorefront(sf)
                    }

                    if (storefrontResponse.errorMessage != "") {
                        setError(storefrontResponse.errorMessage)
                    }
                } else {
                    setError(storefrontResponse.errorMessage)
                }

            })
            .catch((error) => setError(error))
            .finally(() => setLoading(false))
    }, [name]);

    return { storefront, storefrontLoading, storefrontError };
};

// Create a default Storefront object
export const defaultStorefront: Storefront = {
    id: "",
    storeName: "",
    title: "Lead Shop",
    createdAt: "",
    modifiedAt: "",
    emailSignatureHTML: "",
    products: [],
    companyID: "",
    minOrderAmount: 200,
    lookupWalletCredits: 5,
    darkMode: {
      logo: "",
      mainPage: {
        pageButtonBackground: "#ffffff",
        pageIconBackground: "#5462E9",
        pageText: "#201E1F",
        pageMapBorderBackground: "#f2f2f2",
        pageSearchBoxBackground: "#ffffff",
        pageSearchBoxText: "#080b16",
        headerBackground: "#ffffff",
        headerText: "#000000",
        avatarBackground: "#e8e8eb",
        avatarForeground: "5462E9"
      },
      cart: {
        cartBackground: "#efefef",
        cartProductBackground: "#ffffff",
        cartProductRemoveIcon: "#f65c5c",
        cartPurchaseTotalBackground: "#ffffff",
        cartTitleText: "#000000",
        cartProductText: "#000000",
        cartPurchaseText: "#000000",
        cartIconBackground: "#000000",
        cartButtonBackground: "#FE5B35",
        cartPurchaseProgressBackground: "#ffffff",
      },
      addProductForm: {
        formBackground: "#fafafa",
        titleText: "#000000",
        productTitleText: "#444444",
        productText: "#000000",
        iconForeground: "#404242",
        buttonText: "#ffffff",
        buttonBackground: "#1c72b0"
      },
      leftMenu: {
        divider: "#80848E",
        icon: "#80848E"
      },
      pageFooter: {
        text: "#000000"
      }
    },
    lightMode: {
      logo: "",
      mainPage: {
        pageButtonBackground: "#ffffff",
        pageIconBackground: "#5462E9",
        pageText: "#201E1F",
        pageMapBorderBackground: "#f2f2f2",
        pageSearchBoxBackground: "#ffffff",
        pageSearchBoxText: "#080b16",
        headerBackground: "#ffffff",
        headerText: "#000000",
        avatarBackground: "#e8e8eb",
        avatarForeground: "5462E9"
      },
      cart: {
        cartBackground: "#efefef",
        cartProductBackground: "#ffffff",
        cartProductRemoveIcon: "#f65c5c",
        cartPurchaseTotalBackground: "#ffffff",
        cartTitleText: "#000000",
        cartProductText: "#000000",
        cartPurchaseText: "#000000",
        cartIconBackground: "#000000",
        cartButtonBackground: "#FE5B35",
        cartPurchaseProgressBackground: "#ffffff",
      },
      addProductForm: {
        formBackground: "#fafafa",
        titleText: "#000000",
        productTitleText: "#444444",
        productText: "#000000",
        iconForeground: "#404242",
        buttonText: "#ffffff",
        buttonBackground: "#1c72b0"
      },
      leftMenu: {
        divider: "#80848E",
        icon: "#80848E"
      },
      pageFooter: {
        text: "#000000"
      }
    },
    activeColors: {
      logo: "",
      mainPage: {
        pageButtonBackground: "#ffffff",
        pageIconBackground: "#5462E9",
        pageText: "#201E1F",
        pageMapBorderBackground: "#f2f2f2",
        pageSearchBoxBackground: "#ffffff",
        pageSearchBoxText: "#080b16",
        headerBackground: "#ffffff",
        headerText: "#000000",
        avatarBackground: "#e8e8eb",
        avatarForeground: "5462E9"
      },
      cart: {
        cartBackground: "#efefef",
        cartProductBackground: "#ffffff",
        cartProductRemoveIcon: "#f65c5c",
        cartPurchaseTotalBackground: "#ffffff",
        cartTitleText: "#000000",
        cartProductText: "#000000",
        cartPurchaseText: "#000000",
        cartIconBackground: "#000000",
        cartButtonBackground: "#FE5B35",
        cartPurchaseProgressBackground: "#ffffff",
      },
      addProductForm: {
        formBackground: "#fafafa",
        titleText: "#000000",
        productTitleText: "#444444",
        productText: "#000000",
        iconForeground: "#404242",
        buttonText: "#ffffff",
        buttonBackground: "#1c72b0"
      },
      leftMenu: {
        divider: "#80848E",
        icon: "#80848E"
      },
      pageFooter: {
        text: "#000000"
      }
    }
  }